import { useTranslations } from "@src/packages/i18n";
import type { PlanAction, StartTreatmentPresetCycleType } from "../plan.types";
import { JourneyHandoffCard } from "./JourneyHandoffCard";
import { OrganicExplanatoryIllustration } from "./EggFreezingBiologyDeepCarouselCard";

const silkBrown =
  require("@src/apps/moon/assets/images/silk-brown.png") as number;

export function StartEmbryoCycleStep({
  onAction,
  title,
  body,
  ctaLabel,
  checklist,
  presetCycleType = "embryo_freezing",
}: {
  onAction: (action: PlanAction) => void;
  title?: string;
  body?: string;
  ctaLabel?: string;
  checklist?: string[];
  presetCycleType?: StartTreatmentPresetCycleType;
}) {
  const t = useTranslations();
  return (
    <JourneyHandoffCard
      title={title ?? t("homepage.review_concept.start_embryo_cycle_title")}
      body={body ?? t("homepage.review_concept.start_embryo_cycle_body")}
      ctaLabel={ctaLabel ?? t("homepage.review_concept.start_embryo_cycle_cta")}
      checklist={
        checklist ?? [
          t("homepage.review_concept.start_embryo_cycle_checklist_timing"),
          t("homepage.review_concept.start_embryo_cycle_checklist_sperm"),
          t(
            "homepage.review_concept.start_embryo_cycle_checklist_fertilization",
          ),
          t("homepage.review_concept.start_embryo_cycle_checklist_lab_updates"),
        ]
      }
      backgroundImage={silkBrown}
      illustration={<OrganicExplanatoryIllustration kind="follicle-cohort" />}
      onPress={() =>
        onAction({
          label: t("homepage.review_concept.start_embryo_cycle_cta"),
          signal: "open-start-treatment-modal",
          params: { presetCycleType },
        })
      }
    />
  );
}
